import { VueRenderer } from '@tiptap/vue-3';
import tippy from 'tippy.js';
import MentionDropdownList from '@/app/_employees/components/tickets/MentionDropdownList.vue';

export default {
  render() {
    let component;
    let popup;

    return {
      onStart: (props) => {
        component = new VueRenderer(MentionDropdownList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        const editor = document.getElementById('note_editor');

        popup = tippy(editor, {
          getReferenceClientRect: props.clientRect,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'right',
        });
      },

      onUpdate(props) {
        component.updateProps(props);

        if (popup) {
          popup.setProps({
            getReferenceClientRect: props.clientRect,
          });
        }
      },

      onKeyDown(props) {
        if (!component) return false;

        if (props.event.key === 'Escape') {
          if (popup) popup.hide();
          return true;
        }

        if (component.ref) {
          return component.ref.onKeyDown(props);
        }

        return false;
      },

      onExit() {
        if (popup) {
          popup.destroy();
        }
        if (component) {
          component.destroy();
        }
      },
    };
  },
};
